import Icon from '@/components/ui/AppIcon';

interface StatsOverviewProps {
  stats: {
    totalClients: number;
    averageROI: string;
    clientRetention: string;
    referralRate: string;
  };
}

const StatsOverview = ({ stats }: StatsOverviewProps) => {
  const statItems = [
    {
      icon: 'UserGroupIcon',
      label: 'Total Success Stories',
      value: stats.totalClients.toString(),
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      icon: 'ChartBarIcon',
      label: 'Average Client ROI',
      value: stats.averageROI,
      color: 'text-success',
      bgColor: 'bg-success/10',
    },
    {
      icon: 'ArrowPathIcon',
      label: 'Client Retention',
      value: stats.clientRetention,
      color: 'text-accent',
      bgColor: 'bg-accent/10',
    },
    {
      icon: 'HandThumbUpIcon',
      label: 'Referral Rate',
      value: stats.referralRate,
      color: 'text-cta',
      bgColor: 'bg-cta/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {statItems.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-card p-6 hover:shadow-hover transition-shadow duration-300"
        >
          <div className="flex items-center space-x-3">
            <div className={`${stat.bgColor} rounded-lg p-3`}>
              <Icon
                name={stat.icon as any}
                size={24}
                variant="outline"
                className={stat.color}
              />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">{stat.label}</p>
              <p className={`text-2xl font-heading font-bold ${stat.color} mt-1`}>
                {stat.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;